<div class ="main">
    <div class ="header"></div>
        <div class ="start">
            
            <div class = "boxes">
                <div class ="box">
                </div>
                <div class ="box">
                </div>
                <div class ="box">
                </div>
            </div>
 
        </div>
    
</div>